import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { BottomNav } from './BottomNav';
import { LoadingPage } from '../ui/LoadingSpinner';

/**
 * Layout for main tab pages (Home, Books, Progress, Settings).
 * Keeps BottomNav persistent across tab switches — only the content
 * area re-renders, preventing the full-page reload flash.
 */
export function TabLayout() {
  return (
    <>
      <div className="md:ml-[72px]">
        <Suspense fallback={<LoadingPage message="Loading page..." />}>
          <Outlet />
        </Suspense>
      </div>
      <BottomNav />
    </>
  );
}
